export const profileNavKey = {
    ADMIN: 'ADMIN',
    SRTR: 'SRTR',
    TAX: 'TAX',
    UNOS: 'UNOS',
    CENTER_DATA: 'CENTER-DATA',
    LAB: 'LAB',
    SERVICES: 'SERVICES',
    ACCEPTED_INSURANCE: 'ACCEPTED-INSURANCE',
    SEROLOGY_TESTS: 'SEROLOGY-TESTS',
    ANATOMY_PREFS: 'ANATOMY-PREFS',
    LEGAL_DOCUMENTS: 'LEGAL-DOCUMENTS',
    PACKAGING: 'PACKAGING'
};
